import { useCallback } from "react";
import type { ApiError } from "@/types";

interface ErrorDetails {
  title: string;
  message: string;
}

interface ErrorItem {
  property: string;
  error: string;
}

export function useWorkflowErrorHandler() {
  const extractErrorMessage = useCallback((error: unknown): ErrorDetails => {
    const apiError = error as ApiError;

    const title = apiError?.data?.title || "An error occurred";
    const message = extractMessage(apiError?.data?.errors);

    return {
      title,
      message: message || title,
    };
  }, []);

  return { extractErrorMessage };
}

function extractMessage(errors: ApiError["data"]["errors"]): string {
  if (!errors) return "";

  if (Array.isArray(errors)) {
    const firstError = (errors as ErrorItem[]).find((err) => err.error);
    return firstError?.error ?? "";
  }

  if (
    errors.Outputs &&
    Array.isArray(errors.Outputs) &&
    errors.Outputs.length > 0
  ) {
    return errors.Outputs[0];
  }

  const firstErrorKey = Object.keys(errors)[0];
  if (firstErrorKey && Array.isArray(errors[firstErrorKey])) {
    return errors[firstErrorKey][0];
  }

  return "";
}
